import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, HashRouter } from 'react-router-dom';

import App from './containers/App';

import './index.css';
import './styles/main.css';

ReactDOM.render(
    <HashRouter>
      <Router>
          <App />
      </Router>
    </HashRouter>,
    document.getElementById('root')
);
